import { useState } from 'react';

import { Mic, MicOff, VolumeUp } from '@mui/icons-material';
import { Tooltip, IconButton, Slider as MuiSlider } from '@mui/joy';
import { styled } from '@mui/joy/styles';

const Slider = styled(MuiSlider)(() => ({
  '--Slider-thumbColor': '#0a6bcb',
  '--joy-palette-primary-solidHoverBg': '#0a6bcb',
  '--joy-palette-primary-solidActiveBg': '#0a6bcb',
  '& .MuiSlider-track': {
    backgroundColor: '#0a6bcb'
  },
  '& .MuiSlider-thumb': {
    backgroundColor: 'white'
  },
  '& .MuiSlider-rail': {
    backgroundColor: '#e0e0e0',
    opacity: 1
  }
}));

const VolumeControl: React.FC = () => {
  const [micOn, setMicOn] = useState(false);
  const [volume, setVolume] = useState(50);

  const handleMicToggle = () => setMicOn((prev) => !prev);
  const handleVolumeChange = (event: Event, newValue: number | number[]) => {
    setVolume(newValue as number);
  };

  return (
    <div className='flex items-center gap-3'>
      <Tooltip title={micOn ? 'Mic On' : 'Mic Off'}>
        <IconButton color={micOn ? 'primary' : 'neutral'} onClick={handleMicToggle}>
          {micOn ? <Mic /> : <MicOff />}
        </IconButton>
      </Tooltip>
      <VolumeUp />
      <Slider
        aria-labelledby='volume-slider'
        max={100}
        min={0}
        onChange={handleVolumeChange}
        sx={{
          width: 250
        }}
        value={volume}
      />
    </div>
  );
};

export default VolumeControl;
